<mat-form-field class="mat-form-field-full-width">
  <mat-label>{{ placeholder }}</mat-label>
  <input
    *ngIf="type === 'float_number'"
    matInput
    [(ngModel)]="value"
    [min]="min"
    [max]="max"
    [type]="type"
    [name]="placeholder"
    [required]="required"
    [readonly]="readonly"
    [placeholder]="placeholder"
    (change)="selectionChanged($event)"
    (keypress)="allowFloatNumbersOnly($event)"
    #inputRef
  />

  <input
    *ngIf="type === 'int_number'"
    matInput
    [(ngModel)]="value"
    [min]="min"
    [max]="max"
    [type]="type"
    [name]="placeholder"
    [required]="required"
    [readonly]="readonly"
    [placeholder]="placeholder"
    (change)="selectionChanged($event)"
    (keypress)="allowIntNumbersOnly($event)"
    #inputRef
  />

  <input
    *ngIf="type !== 'float_number' && type !== 'int_number'"
    matInput
    [(ngModel)]="value"
    [min]="min"
    [max]="max"
    [type]="type"
    [name]="placeholder"
    [required]="required"
    [readonly]="readonly"
    [placeholder]="placeholder"
    (change)="selectionChanged($event)"
    #inputRef
    string-input-directive
  />

  <mat-icon *ngIf="toolTipText" style="color: #f49602" [tooltip]="toolTipText" matSuffix>info</mat-icon>

  <div *ngIf="(min && value < min) || (min && value > max)" class="error">
    <p>Allowed range is {{ min }} to {{ max }}</p>
  </div>

  <div *ngIf="value && value.length > max_chars" class="error">
    <p>Max characters: {{ max_chars }}</p>
  </div>
</mat-form-field>
